<script lang="ts">
    import Button from "@/lib/components/ui/button/button.svelte";
    import { Separator } from "@/lib/components/ui/separator";

    export let mode: 'login' | 'signup' = 'login'

    const label = mode === 'signup' ? 'Sign up' : 'Continue'

    // The buttons are plain links, so there is no request body to put the browser
    // timezone in — pass it as a query parameter for SocialAuthController to stash
    // before the OAuth round trip. Without this every social signup would land on
    // the server's default timezone.
    let timezone = ''
    try { timezone = Intl.DateTimeFormat().resolvedOptions().timeZone ?? '' } catch {}

    const query = timezone ? `?tz=${encodeURIComponent(timezone)}` : ''
</script>

<div class="space-y-3">
    <!-- Google -->
    <Button href="/auth/social/google/redirect{query}" variant="outline" class="w-full gap-3 font-normal">
        <svg class="w-5 h-5 shrink-0" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
            <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
            <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05"/>
            <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
        </svg>
        {label} with Google
    </Button>

    <!-- Strava — asks for the sync scopes too, so the wizard can import activities -->
    <Button href="/auth/social/strava/redirect{query}" variant="outline" class="w-full gap-3 font-normal">
        <img src="/assets/images/providers/strava_full.svg" alt="" aria-hidden="true" class="h-4 shrink-0" />
        {label} with Strava
    </Button>

    {#if mode === 'signup'}
        <p class="text-xs text-muted-foreground text-center leading-snug">
            By continuing you agree to our
            <a href="/legal/terms" target="_blank" rel="noopener" class="underline hover:text-foreground">Terms of Service</a>
            and
            <a href="/legal/privacy" target="_blank" rel="noopener" class="underline hover:text-foreground">Privacy Policy</a>.
        </p>
    {/if}

    <div class="relative">
        <Separator />
        <span class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 bg-card px-2 text-xs text-muted-foreground">
            or
        </span>
    </div>
</div>
